/*
 * Framework
 *
 * Namespace
 */
(function () {
  'use strict';

  // namespace app
  this.Framework = {
    CONSTANTS: {
      MQ: {
        xSmall: 480,
        small: 768,
        medium: 992,
        large: 1100,
        xLarge: 1200,
      },
    },
  };
}.call(window));
